/* eslint-disable prefer-template */
import Layout from "../../../../components/Layout";
import useStyles from "../../styles";
import Button from "../../../../components/Button";
import PageTitle from "../../../../components/PageTitle";
import BreadCrumb from "../../../../components/BreadCrumb";
import { useState, useEffect } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Icon } from "@iconify/react";
import { Grid, Menu,
  MenuItem,
  IconButton, useMediaQuery, Checkbox, FormControlLabel, Tooltip, Switch } from "@mui/material";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import Badge from "../../../../components/Badge";
import { httprequest } from "../../../../data/api";
import { useParams, useNavigate, useSearchParams, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import WidgetTitle from "../../../dashboard/components/WidgetTitle/WidgetTitle";
import AssignmentDetailText from "../../../assignment/components/AssignmentDetailText";
import useWindowSize from "../../../../hooks/useWindow";
import Table from "../../../../components/Table/Table";
import { TableSearch } from "../../../../components/Table/TableActions";
import { saveAs } from "file-saver";
import HTMLDocx from "html-docx-js/dist/html-docx";
import Modal from "../../../../components/Modal";
import NotFounditem from "../../../error/NotFound";
import noexam from "../../../../assets/images/noexam.svg";
import { useUserState } from "../../../../context/UserContext";
import { questionDisplayIndex } from "../../../../utils/questionDisplayIndex";
import { loadScheduleOffFieldsFromApi, formatTimeForApi, isExamEndAfterStart, getScheduleWindowMinutes } from "../../../../utils/examScheduleDatetime";
import useValidator from "../../../../hooks/useValidator";
import RightDrawer from "../../../../components/RightDrawer";
import BulkQuestionImport from "../../../../components/BulkQuestionImport";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import Select from "react-select";

import GenerateQuestionsDrawer from "../../../lessonnote/component/GenerateQuestionsDrawer";
import questionCsvUrl from "../../../../assets/sample/question.csv";
import questionsXlsxUrl from "../../../../assets/sample/questions.xlsx";

const EXAM_CONFIG_ENDPOINT = "/api/v1/examination-configs";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const TEACHER_SUBJECT_FOR_CLASS_ENDPOINT = "/api/v1/teacher/class-subject/";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT_ENDPOINT = "/api/v1/class-subject/";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";
const SESSION_ENDPOINT = "/api/v1/school-plan/session";

/** Stable component for edit-questions modal so inputs don't remount on every keystroke */
function EditQuestionsModalContent(props) {
  const {
    editQuestionArr,
    styles,
    options,
    editQuestionsValidator,
    isSmallScreen,
    isUpdatingDraft,
    isPublishing,
    onQueChange,
    onQueTypeChange,
    onQuePointChange,
    onCorrectChoiceChange,
    onMultipleChoiceChange,
    onAdditionalOptions,
    onAdditionalQuestion,
    onRemoveQuestion,
    onRemoveChoice,
    onQueDescChange,
    onMenuClick,
    onMenuClose,
    onToggleDescription,
    onRemoveDescription,
    editAnchorEl,
    editMenuOpen,
    onAddToBankChange,
    onUpdateDraft,
    onUpdatePublish,
    publishButtonLabel,
    hideAddQuestionRow = false,
    onQueImageChange,
    onOptionImageChange,
    onRemoveQueImage,
    onRemoveOptionImage,
    onIconClick,
    onIconOptionClick
  } = props;

  return (
    <>
      <div className="margin-top">
        <Grid container spacing={2}>
          {editQuestionArr?.map((que, queInd) => (
            <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={styles.quesaction}>
                      <label className={styles.quelabel}>Enter Question {queInd + 1}</label>
                      {editQuestionArr?.length > 1 ? (
                        <Icon
                          icon="material-symbols:delete-outline"
                          width="20"
                          height="20"
                          className="delete-icon"
                          onClick={() => onRemoveQuestion(queInd)}
                        />
                      ) : null}
                    </div>
                    <div className={styles.textandimgmain}>
                      <div className={styles.textandimg}>
                        <input
                          type="text"
                          placeholder={que?.file?.file_url ? "" : "Type Question"}
                          name="question_text"
                          value={que?.question_text ?? ""}
                          onChange={(e) => onQueChange(e, queInd)}
                        />
                        {editQuestionsValidator.message(`edit_q_text_${queInd}`, (que?.question_text ?? "").trim(), "required")}

                        <div onClick={() => onIconClick(queInd)} className={styles.queimg}>
                          <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                          <input
                            type="file"
                            accept="image/*"
                            id={`editImageInput-${queInd}`}
                            multiple
                            onChange={(e) => onQueImageChange(e, queInd)}
                            style={{ display: "none" }}
                          />
                        </div>

                        {que?.file?.file_url ? (
                          <div className={styles.preiewcont}>
                            <img src={que.file.file_url} alt="" />
                            <Icon
                              icon="material-symbols:delete-outline"
                              width="20"
                              height="20"
                              className="delete-icon"
                              onClick={() => onRemoveQueImage(queInd)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Add Answer Type"
                      required
                      children={
                        <select
                          name="type"
                          value={que?.type ?? ""}
                          onChange={(e) => onQueTypeChange(e, queInd)}
                        >
                          <option value="">--- Select ---</option>
                          {options?.map((label) => (
                            <option key={label?.value} value={label?.value}>{label?.text}</option>
                          ))}
                        </select>
                      }
                    />
                    {editQuestionsValidator.message(`edit_q_type_${queInd}`, que?.type, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      className={styles.pointsInput}
                      label="Question Point"
                      inputType="number"
                      inputName="grade_point"
                      placeHolder="Enter Question Points"
                      value={que?.grade_point ?? ""}
                      onChange={(e) => onQuePointChange(e, queInd)}
                    />
                    {editQuestionsValidator.message(`edit_q_points_${queInd}`, que?.grade_point != null && String(que.grade_point).trim() !== "" ? que.grade_point : null, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {"description" in que && que?.description != null ? (
                      <div className="margin-top full-width">
                        <div className=" flex gap-10 justify-items-space">
                          <label className={styles.enterque}>Question Description</label>
                          <div className="delete-icon" onClick={() => onRemoveDescription(queInd)}>
                            <Icon icon="ooui:close" width="20" height="20" />
                          </div>
                        </div>
                        <div className={styles.textandimgmain}>
                          <input
                            type="text"
                            placeHolder="Enter Description"
                            name="description"
                            value={que?.description ?? ""}
                            onChange={(e) => onQueDescChange(e, queInd)}
                          />
                        </div>
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    {(que?.options || []).map((opt, i) => (
                      <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                        <div>
                          <div className=" flex gap-10 justify-items-space">
                            <label className={styles.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                            {que?.options?.length > 1 && que?.type !== "true_false" ? (
                              <Icon onClick={() => onRemoveChoice(i, queInd)} className="delete-icon" icon="ooui:close" width="20" height="20" />
                            ) : null}
                          </div>
                          <div className={styles.textandimgmain}>
                            <div className={styles.textandimg}>
                              <input
                                type="text"
                                placeholder="Enter option"
                                value={typeof opt === "object" ? (opt?.text ?? opt?.file_url ?? "") : (opt ?? "")}
                                onChange={(e) => onMultipleChoiceChange(e, i, queInd)}
                                disabled={que?.type === "true_false"}
                              />
                              {que?.type !== "true_false" && (
                                <>
                                  <div onClick={() => onIconOptionClick(i, queInd)} className={styles.queimg}>
                                    <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id={`editImageInput-${i}${queInd}`}
                                      onChange={(e) => onOptionImageChange(e, i, queInd)}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {typeof opt === "object" && opt?.file_url ? (
                                    <div className={styles.preiewoptioncont}>
                                      <img src={opt.file_url} alt={`Option ${i + 1}`} />
                                      <Icon
                                        icon="material-symbols:delete-outline"
                                        width="20"
                                        height="20"
                                        className="delete-icon"
                                        onClick={() => onRemoveOptionImage(i, queInd)}
                                      />
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="text-align-left" style={{ marginTop: 5 }}>
                            <div className={styles.correctcontainer}>
                              <input
                                type={que?.type === "checkbox" ? "checkbox" : "radio"}
                                name={que?.type === "checkbox" ? "edit-answer" : `edit-answer-${queInd}`}
                                value={i}
                                checked={que?.type === "checkbox" ? (que?.answer || []).includes(i) : (que?.answer || [])[0] === i}
                                onChange={(e) => onCorrectChoiceChange(e, i, queInd)}
                              />
                              <label className={styles.correctlabel}>is correct</label>
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                )}
                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <div style={{ marginTop: 4 }}>
                    {editQuestionsValidator.message(`edit_q_answer_${queInd}`, (que?.answer?.length > 0) ? que.answer : null, "required")}
                  </div>
                )}
                {que?.type === "multiple_choice" && (
                  <div className={styles.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another option</p>
                  </div>
                )}
                {que?.type === "checkbox" && (
                  <div className={styles.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another checkbox</p>
                  </div>
                )}
                <div className={styles.questionfooter}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!que?.add_to_bank}
                        onChange={(e) => onAddToBankChange(e, queInd)}
                        size="small"
                      />
                    }
                    label="Add to Question Bank"
                    sx={{ marginRight: 1 }}
                  />
                  {!que?.description && (
                    <IconButton aria-label="more" onClick={(e) => onMenuClick(e, queInd)}>
                      <Icon icon="radix-icons:dots-vertical" width="20" height="20" />
                      <label className={styles.enterque}>More</label>
                    </IconButton>
                  )}
                </div>
                <Menu anchorEl={editAnchorEl} open={editMenuOpen} onClose={onMenuClose}>
                  <MenuItem onClick={onToggleDescription}>Add Description on Question</MenuItem>
                </Menu>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
      {!hideAddQuestionRow && (
        <div className={styles.addque}>
          <Icon icon="octicon:feed-plus-16" width="16" height="16" />
          <p onClick={onAdditionalQuestion}>Add question</p>
        </div>
      )}
      <div className={styles.btnwrapper}>
        {publishButtonLabel !== "Withdraw" && (
          <Button
            variant="primaryoutline"
            buttonSize={isSmallScreen ? "full" : "fluid"}
            color="btnfontprimary"
            buttonName="Update Question"
            isLoading={isUpdatingDraft}
            onClick={onUpdateDraft}
          />
        )}
        <Button
          variant="primary"
          buttonSize={isSmallScreen ? "full" : "fluid"}
          color="btndefault"
          buttonName={publishButtonLabel}
          isLoading={isPublishing}
          onClick={onUpdatePublish}
        />
      </div>
    </>
  );
}

const SchoolExamDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [schoolExamData, setSchoolExamData] = useState([]);
  const [examAttendees, setExamAttendees] = useState([]);
  const [attendeeFilter, setAttendeeFilter] = useState([]);
  const [value, setValue] = useState("1");
  const width = useWindowSize();
  const mobile = width < 600;
  const [isGenerateDrawerOpen, setIsGenerateDrawerOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [exportMenuAnchor, setExportMenuAnchor] = useState(null);
  const [isBatchImportModalOpen, setIsBatchImportModalOpen] = useState(false);
  const [isBatchImportLoading, setIsBatchImportLoading] = useState(false);
  const [batchFileType, setBatchFileType] = useState("csv");
  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isEditQuestionsModalOpen, setIsEditQuestionsModalOpen] = useState(false);
  const [isMetadataDrawerOpen, setIsMetadataDrawerOpen] = useState(false);
  const [initialMetadataForm, setInitialMetadataForm] = useState(null);
  const [editQuestionArr, setEditQuestionArr] = useState([]);
  const [isUpdatingDraftQuestions, setIsUpdatingDraftQuestions] = useState(false);
  const [isPublishingQuestions, setIsPublishingQuestions] = useState(false);
  const styles = useStyles();
  const { userRole } = useUserState();

  const editHandleQuestionImageChange = async (event, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response?.data?.data?.[0]?.upload_id,
            file_url: response?.data?.data?.[0]?.file_url
          };
          setEditQuestionArr((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: uploadedImageDetails } : q));
          toast.success(`Image added to question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  const editHandleOptionImageChange = async (event, optionIndex, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };
          setEditQuestionArr((prev) => prev.map((q, qIndex) => {
            if (qIndex === queInd) {
              const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? uploadedImageDetails : opt);

              return { ...q, options: updatedOptions };
            }

            return q;
          }));
          toast.success(`Image added to option ${optionIndex + 1} in question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  const editRemoveQueImage = async (queInd) => {
    const upload_id = editQuestionArr[queInd]?.file?.upload_id;
    if (!upload_id) {
      toast.error("No upload ID found for this question");

      return;
    }
    try {
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
      if (response?.status === 200) {
        setEditQuestionArr((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: { upload_id: "", file_url: "" } } : q));
        toast.success(`Image removed from question ${queInd + 1}`);
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  const editRemoveOptionImage = async (optionIndex, queInd) => {
    const option = editQuestionArr[queInd]?.options?.[optionIndex];
    const upload_id = option?.upload_id;
    if (!upload_id) {
      toast.error("No upload ID found for this option");

      return;
    }
    try {
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
      if (response?.status === 200) {
        setEditQuestionArr((prev) => prev.map((q, qIndex) => {
          if (qIndex === queInd) {
            const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? { ...opt, upload_id: "", file_url: "" } : opt);

            return { ...q, options: updatedOptions };
          }

          return q;
        }));
        toast.success(`Option ${optionIndex + 1} image removed successfully`);
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  const editHandleIconClick = (queInd) => {
    document.getElementById(`editImageInput-${queInd}`).click();
  };

  const editHandleIconOptionClick = (i, queInd) => {
    document.getElementById(`editImageInput-${i}${queInd}`).click();
  };
  // const [subjectData, setSubjectData] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [isDrafting, setIsDrafting] = useState(false);
  const [classData, setClassData] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [allTerm, setAllTerms] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [currentAnchor, setCurrentAnchor] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [createExamValidator, showCreateExamValidator] = useValidator();
  const [editQuestionsValidator, showEditQuestionsValidator] = useValidator();
  // const [selectedClassSubjects, setSelectedClassSubjects] = useState([]);
  const [disabledInputs, setDisabledInputs] = useState({});
  const [questionImages, setQuestionImages] = useState({});
  const [totalPoints, setTotalPoints] = useState(0);
  const [optionimages, setOptionImages] = useState([]);
  // const [descimages, setDescImages] = useState([]);
  const isTeacher = userRole?.role_type === "employee";
  const isAdmin = userRole?.role_type === "school_admin";
  const [metadataForm, setMetadataForm] = useState({
    class_id: [],
    subject_id: "",
    session_id: "",
    term_id: "",
    title: "",
    description: "",
    instruction: "",
    duration: 0,
    total_grade: 0,
    time_per_question: "",
    exam_date: "",
    start_time: "",
    end_time: "",
    use_exam_schedule: true,
    random_question: "no",
    random_options: "no",
    display_score_after_exam: "no",
    question_display_mode: "",
    proctoring_requirements: "",
    browser_lockdown: false,
    is_private: false
  });

  /**
 * Handles tab change event
 * @param {Event} event - The event object
 * @param {string} newValue - The new tab value
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isSmallScreen = useMediaQuery("(max-width: 700px)");

  /**
 * Handles the change event for uploading a description image.
 * Converts the selected image file to a local URL and sets it in state.
 *
 * @param {event parameter passed on handleChange} event - The file input change event.
 */
  // const handleDescImageChange = (event) => {
  //   if (event?.target?.files?.length > 0) {
  //     const selectedImage = URL.createObjectURL(event?.target?.files[0]);
  //     setDescImages([selectedImage]);
  //   }
  // };

  const [questionArr, setQuestionArr] = useState([]);

  const [schoolExaminationForm, setSchoolExamForm] = useState({
    status: "",
    questions: [
      {
        question_index: 1
      }
    ]
  });

  /**
 * Handles image upload for a specific question and updates state.
 * @param {Event} event - The file input change event.
 * @param {number} queInd - Index of the question being updated.
 */
  const handleQuestionImageChange = async (event, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response?.data?.data?.[0]?.upload_id,
            file_url: response?.data?.data?.[0]?.file_url
          };

          // Update questionArr with the uploaded image details
          const updatedQuestionArr = questionArr.map((question, index) => index === queInd
            ? { ...question, file: uploadedImageDetails }
            : question
          );
          setQuestionArr(updatedQuestionArr);

          // Update schoolExaminationForm questions with the new questionArr
          setSchoolExamForm((prevForm) => ({
            ...prevForm,
            questions: updatedQuestionArr
          }));

          // Add image URL to questionImages state for preview
          const imageUrl = URL.createObjectURL(file);
          setQuestionImages((prevImages) => ({
            ...prevImages,
            [queInd]: imageUrl
          }));
          toast.success(`Image added to question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
   * Handles image upload for a specific option in a question.
   * @param {Event} event - The file input change event.
   * @param {number} optionIndex - Index of the option being updated.
   * @param {number} questionIndex - Index of the question containing the option.
   */
  const handleOptionImageChange = async (event, optionIndex, questionIndex) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      setDisabledInputs((prevDisabled) => ({
        ...prevDisabled,
        [questionIndex]: {
          ...prevDisabled[questionIndex],
          [optionIndex]: true
        }
      }));

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };

          // Update the specific option with only upload_id and file_url
          const updatedQuestionArr = questionArr.map((question, qIndex) => {
            if (qIndex === questionIndex) {
              const updatedOptions = question.options.map((option, oIndex) => oIndex === optionIndex
                ? uploadedImageDetails
                : option
              );

              return { ...question, options: updatedOptions };
            }

            return question;
          });

          setQuestionArr(updatedQuestionArr);

          // Update schoolExaminationForm questions with the new questionArr
          setSchoolExamForm((prevForm) => ({
            ...prevForm,
            questions: updatedQuestionArr
          }));

          const imageUrl = URL.createObjectURL(file);
          setOptionImages((prevImages) => ({
            ...prevImages,
            [`${questionIndex}-${optionIndex}`]: imageUrl
          }));

          toast.success(`Image added to option ${optionIndex + 1} in question ${questionIndex + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
   * Deletes an uploaded image for a specific question.
   * @param {number} queInd - Index of the question whose image is to be removed.
   */
  const removeQueImage = async (queInd) => {
    const upload_id = questionArr[queInd]?.file?.upload_id;

    if (!upload_id) {
      toast.error("No upload ID found for this question");

      return;
    }

    try {
      // This makes a DELETE request to remove the image from the database
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);

      if (response?.status === 200) {
        // Image successfully removed, also updates the questionArr to remove the image for the specific question
        setQuestionArr((prevQuestions) => prevQuestions.map((question, index) => index === queInd
          ? {
            ...question,
            file: { upload_id: "", file_url: "" }
          }
          : question
        )
        );

        // Remove image preview from the state
        setQuestionImages((prevImages) => {
          const updatedImages = { ...prevImages };
          delete updatedImages[queInd];

          return updatedImages;
        });
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  /**
   * Deletes an uploaded image for a specific option in a question.
   * @param {number} i - Index of the option.
   * @param {number} queInd - Index of the question containing the option.
   */
  const removeOptionImage = async (i, queInd) => {
    const question = questionArr[queInd];
    const option = question?.options?.[i];
    const upload_id = option?.upload_id;

    if (!question || !option) {
      toast.error("Question or option not found");

      return;
    }

    if (!upload_id) {
      toast.error("No upload ID found for this option");

      return;
    }

    try {
      // DELETE request to remove the image of the option
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);

      if (response?.status === 200) {
        // Image haes been removed, update the questionArr to remove the image for the specific option
        setQuestionArr((prevQuestions) => prevQuestions.map((question, index) => {
          if (index === queInd) {
            const updatedOptions = question.options.map((option, optionIndex) => optionIndex === i ? { ...option, upload_id: "", file_url: "" } : option
            );

            return { ...question, options: updatedOptions };
          }

          return question;
        })
        );

        // Remove image preview from the state
        setOptionImages((prevImages) => {
          const updatedImages = { ...prevImages };
          delete updatedImages[`${queInd}-${i}`];

          return updatedImages;
        });

        toast.success(`Option ${i + 1} of Question ${queInd + 1} image removed successfully`);
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  useEffect(() => {
  }, [optionimages]);

  /**
 * Triggers click on hidden file input for question image.
 * @param {number} queInd - Index of the question.
 */
  const handleIconClick = (queInd) => {
    document.getElementById(`imageInput-${queInd}`).click();
  };
    /**
 * Triggers click on hidden file input for option image.
 * @param {number} i - Index of the option.
 * @param {number} queInd - Index of the question.
 */
  const handleIconOptionClick = (i, queInd) => {
    document.getElementById(`imageInput-${i}${queInd}`).click();
  };

  /**
 * creates Exam with status "published".
 */
  const handleCreateExam = () => {
    if (createExamValidator.allValid()) {
      const questionsPayload = (questionArr || []).map((q) => {
        const optionValues = (q.options || []).map((opt) => {
          if (typeof opt === "object" && opt !== null && (opt?.file_url || opt?.text != null)) {
            const textVal = opt?.text != null && opt.text !== "" ? opt.text : null;
            const fileVal = opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : null;

            return textVal ?? fileVal ?? opt;
          }

          return opt;
        });

        return {
          type: q.type,
          question_text: (q.question_text || q.question || "").trim(),
          options: optionValues,
          answer: Array.isArray(q.answer) ? q.answer : (q.answer != null && q.answer !== "" ? [q.answer] : []),
          grade_point: Number(q.grade_point) || 0,
          add_to_bank: !!q.add_to_bank,
          required: !!q.required
        };
      });

      /** Same as edit modal publish: POST exam resource so status becomes published (not only config /questions). */
      setIsCreating(true);
      httprequest
        .post(`${isTeacher ? "/api/v1/school-exams" : "/api/v1/exams"}/${id}`, { status: "published", questions: questionsPayload })
        .then((res) => {
          setIsCreating(false);
          setIsAddQuestionModalOpen(false);
          toast.success(res?.data?.message);
          if (isTeacher) {
            navigate("/examinations");
          } else {
            navigate("/school-examination/examination");
          }
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showCreateExamValidator(true);
    }
  };

  /**
 * saves exam with status "draft".
 */
  const handleCreateDraftExam = () => {
    if (createExamValidator.allValid()) {
      const configId = schoolExamData?.config?.id ?? id;
      const questionsPayload = (questionArr || []).map((q) => {
        const optionValues = (q.options || []).map((opt) => {
          if (typeof opt === "object" && opt !== null && (opt?.file_url || opt?.text != null)) {
            const textVal = opt?.text != null && opt.text !== "" ? opt.text : null;
            const fileVal = opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : null;

            return textVal ?? fileVal ?? opt;
          }

          return opt;
        });

        return {
          type: q.type,
          question_text: (q.question_text || q.question || "").trim(),
          options: optionValues,
          answer: Array.isArray(q.answer) ? q.answer : (q.answer != null && q.answer !== "" ? [q.answer] : []),
          grade_point: Number(q.grade_point) || 0,
          add_to_bank: !!q.add_to_bank,
          required: !!q.required
        };
      });

      setIsDrafting(true);
      httprequest
        .patch(`${EXAM_CONFIG_ENDPOINT}/${configId}/questions`, { questions: questionsPayload })
        .then((res) => {
          setIsDrafting(false);
          toast.success(res?.data?.message);
          if (isTeacher) {
            navigate("/examinations");
          } else {
            navigate("/school-examination/examination");
          }
        })
        .catch((err) => {
          setIsDrafting(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showCreateExamValidator(true);
    }
  };

  // const handleCreateExam = () => {
  //   handlePostAssignment("published");
  // };
  /**
 * Handles click on additional menu icon for question.
 * @param {React.MouseEvent} event
 * @param {number} queInd - Index of the question.
 */
  const handleClick = (event, queInd) => {
    setAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
    /**
 * Closes the additional question menu.
 */
  const handleAdditionalQueClose = () => {
    setAnchorEl(null);
  };

  /**
   *
   * @param {event parameter passed on handleChange} e
   * @param {*} index
   * @param {*} queInd
   */
  const handleMultipleChoiceChange = (e, index, queInd) => {
    const { value } = e.target;

    const options = questionArr[queInd]["options"];
    const newOptionArr = [...options];

    // Update the specific option as a string when typing
    newOptionArr[index] = value;

    const newQueArr = [...questionArr];
    newQueArr[queInd]["options"] = newOptionArr;

    setQuestionArr(newQueArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQueArr });
  };

  /**
   *
   * @param {event parameter passed on handleChange} e
   * @param {*} index
   * @param {*} queInd
   */
  const handleCorrectChoiceChange = (e, index, queInd) => {
    const { checked, type } = e.target;

    if (type === "radio") {
      const newQuestionArr = questionArr.map((q, i) => (i === queInd ? { ...q, answer: [index] } : q));
      setQuestionArr(newQuestionArr);
      setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
    } else if (type === "checkbox") {
      const prevAnswers = questionArr[queInd]?.answer || [];
      const newAnswers = checked
        ? prevAnswers.includes(index) ? prevAnswers : [...prevAnswers, index]
        : prevAnswers.filter((a) => a !== index);
      const newQueArr = questionArr.map((q, i) => (i === queInd ? { ...q, answer: newAnswers } : q));
      setQuestionArr(newQueArr);
      setSchoolExamForm({ ...schoolExaminationForm, questions: newQueArr });
    }
  };

  /**
 * Handles change to the main question text.
 * @param {event parameter passed on handleQueChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  };

  /**
 * Handles change to the main question text.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueDescChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  };

  /**
 * Handles change to question point value and updates total.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQuePointChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);

    const newTotalPoints = newQuestionArr.reduce((sum, question) => {
      return sum + (parseFloat(question?.grade_point) || 0);
    }, 0);

    setSchoolExamForm({
      ...schoolExaminationForm,
      questions: newQuestionArr,
      total_grade: newTotalPoints
    });

    setTotalPoints(newTotalPoints);
  };

  /**
 * Adds an empty option to the given question.
 * @param {number} queInd - Index of the question.
 */
  const handleAdditionalOptions = (queInd) => {
    const newQueArr = [...questionArr];
    const newRadioArr = [...questionArr[queInd]["options"], [" "]];
    newQueArr[queInd]["options"] = newRadioArr;
    setQuestionArr(newQueArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQueArr });
  };

  /**
 * Handles change to question type (e.g., from short answer to multiple choice).
 * Initializes options if they are empty.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    if (value === "true_false") {
      newQuestionArr[index]["options"] = ["True", "False"];
      newQuestionArr[index]["answer"] = [];
    } else if (newQuestionArr[index]["options"].length === 0) {
      handleAdditionalOptions(index);
    }
    setQuestionArr(newQuestionArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  };

  /**
 * Adds a description field to a question.
 */
  const toggleQueDescriptionTrue = () => {
    const newQuestionArr = [...questionArr];
    newQuestionArr[currentAnchor]["description"] = "";
    setQuestionArr(newQuestionArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  };

  /**
 * Removes the description field from a question.
 * @param {number} index - Index of the question.
 */
  const removeQueDescription = (index) => {
    const newQuestionArr = [...questionArr];
    delete newQuestionArr[index]["description"];
    setQuestionArr(newQuestionArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  };

  // This Updates the value on the required field on each question.
  // const handleReqQueChange = (e, index) => {
  //   const { name, checked } = e.target;
  //   const newQuestionArr = [...questionArr];
  //   newQuestionArr[index][name] = checked;
  //   setQuestionArr(newQuestionArr);
  //   setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
  // };

  /**
 * Adds a new blank question to the question array and updates the assignment form state.
 * The new question includes default values such as empty strings and a single empty option.
 */
  const handleAdditionalQuestion = () => {
    const newQue = {
      question: "",
      question_index: (questionArr?.length ?? 0) + 1,
      type: "",
      answer: "",
      required: false,
      grade_point: "",
      options: [""]
    };

    // Update questionArr
    const updatedQuestionArr = [...questionArr, newQue];
    setQuestionArr(updatedQuestionArr);

    // Update schoolExaminationForm with new the question
    setSchoolExamForm((prevForm) => ({
      ...prevForm,
      questions: updatedQuestionArr
    }));
  };

  /**
 * Removes an additional question that was added, based on its index.
 *
 * @param {number} index - The index of the question to be removed from the question array.
 */
  const removeAdditionalQue = (index) => {
    const newQueArr = questionArr.filter((_item, ind) => ind !== index);
    setQuestionArr(newQueArr);
    setSchoolExamForm((prev) => ({ ...prev, questions: newQueArr }));
  };

  /**
 * Removes an additional option choice from a question's options list based on the option index and question index.
 *
 * @param {number} index - The index of the option to remove.
 * @param {number} queInd - The index of the question containing the option.
 */
  const removeAdditionalChoice = (index, queInd) => {
    const newQueArr = [...questionArr];
    const newChoiceArr = newQueArr[queInd]["options"]?.filter(
      (_item, ind) => ind !== index
    );
    newQueArr[queInd]["options"] = newChoiceArr;
    setQuestionArr(newQueArr);
    setSchoolExamForm({ ...schoolExaminationForm, questions: newQueArr });
  };

  // --- Edit questions modal handlers (work on editQuestionArr) ---
  const editHandleQueChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => {
      const next = prev.map((q, i) => (i === index ? { ...q, [name]: value } : q));

      return next;
    });
  };

  const editHandleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => {
      const next = prev.map((q, i) => {
        if (i !== index) return q;
        if (value === "true_false") return { ...q, [name]: value, options: ["True", "False"], answer: [] };
        const options = q.options?.length > 0 ? q.options : [""];

        return { ...q, [name]: value, options };
      });

      return next;
    });
  };

  const editHandleQuePointChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => {
      return prev.map((q, i) => (i === index ? { ...q, [name]: value } : q));
    });
  };

  const editHandleCorrectChoiceChange = (e, index, queInd) => {
    const { checked, type } = e.target;
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q) return prev;
      if (type === "radio") {
        next[queInd] = { ...q, answer: [index] };

        return next;
      }
      const answers = q.answer || [];
      if (checked) {
        next[queInd] = { ...q, answer: answers.includes(index) ? answers : [...answers, index] };
      } else {
        next[queInd] = { ...q, answer: answers.filter((i) => i !== index) };
      }

      return next;
    });
  };

  const editHandleMultipleChoiceChange = (e, optionIndex, questionIndex) => {
    const { value } = e.target;
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[questionIndex];
      if (!q?.options) return prev;
      const newOptions = [...q.options];
      newOptions[optionIndex] = typeof newOptions[optionIndex] === "object" && newOptions[optionIndex] !== null
        ? { ...newOptions[optionIndex], text: value }
        : value;
      next[questionIndex] = { ...q, options: newOptions };

      return next;
    });
  };

  const editHandleAdditionalOptions = (queInd) => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      const opts = q?.options?.length ? [...q.options, " "] : [" "];
      next[queInd] = { ...q, options: opts };

      return next;
    });
  };

  const editHandleAdditionalQuestion = () => {
    setEditQuestionArr((prev) => [
      ...prev,
      {
        question_text: "",
        type: "",
        options: [""],
        answer: [],
        grade_point: 0,
        id: null,
        file: {},
        add_to_bank: false,
        required: false,
        question_index: (prev?.length ?? 0) + 1
      }
    ]);
  };

  const removeEditQuestion = (index) => {
    setEditQuestionArr((prev) => prev.filter((_, i) => i !== index));
  };

  const removeEditChoice = (optionIndex, queInd) => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q?.options?.length) return prev;
      const newOptions = q.options.filter((_, i) => i !== optionIndex);
      next[queInd] = { ...q, options: newOptions.length ? newOptions : [""] };

      return next;
    });
  };

  const editHandleQueDescChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };

  const [editAnchorEl, setEditAnchorEl] = useState(null);
  const editMenuOpen = Boolean(editAnchorEl);
  const editHandleClick = (event, queInd) => {
    setEditAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const editHandleMenuClose = () => setEditAnchorEl(null);
  const editToggleQueDescriptionTrue = () => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const idx = currentAnchor;
      if (next[idx]) next[idx] = { ...next[idx], description: "" };

      return next;
    });
    editHandleMenuClose();
  };

  const editRemoveQueDescription = (index) => {
    setEditQuestionArr((prev) => prev.map((q, i) => {
      if (i !== index) {
        return q;
      }
      const { ...rest } = q;
      delete rest.description;

      return rest;
    }));
  };

  /**
 * Array of column definitions for the data table
 * @type {Array<Object>}
 */
  const columns = [
    {
      name: "Student Name",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {`${row?.student?.last_name || "--/--"} ${row?.student?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Subject",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject?.name || "--/--"}
        </>
      )
    },
    // {
    //   name: "Status",
    //   selector: (row) => (
    //     <>
    //       {mobile && <p className="mobile-styling">Status</p>}
    //       {<Badge status={row?.status} />}
    //     </>
    //   )
    // },
    {
      name: "Total Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Total Score</p>}
          {row?.exam_attainable_score || "--/--"}
        </>
      )
    },
    {
      name: "Student Score",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Score</p>}
          {row?.total_score || "--/--"}
        </>
      )
    },
    {
      name: "View",
      center: true,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/exam-result-details/${row?.submission_id || row?.id}`} className="table-action-icon">
            <Icon icon="ph:arrow-right-bold" width="20" height="20" />
          </Link>
        </div>
      )
    }
  ];

  /**
 * Fetches exam attendees data from the server
 */
  const getExamAttendees = () => {
    httprequest.get(`${isTeacher ? "/api/v1/school-exams" : "/api/v1/exams"}/${id}/result`).then((res) => {
      setExamAttendees(res?.data?.data);
      setAttendeeFilter(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Filters attendees table based on search input
 * @param {Event} e - The input change event
 */
  const handleSearchAssignmentByClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = examAttendees?.filter((data) => valArray?.every(
      (word) => data?.student?.last_name
        ?.toLowerCase()
        .includes(word?.toLowerCase()) ||
        data?.student?.first_name
          ?.toLowerCase()
          .includes(word?.toLowerCase()) ||
        data?.status
          ?.toLowerCase()
          .includes(word?.toLowerCase())
    )
    );
    setAttendeeFilter(result);
  };

  /**
 * Fetches examination details by ID
 */
  const getEnrolmentExaminationById = () => {
    httprequest.get(`${isTeacher ? "/api/v1/school-exams" : "/api/v1/exams"}/${id}`).then((res) => {
      const rawData = res?.data?.data;
      const config = rawData?.config;

      // For non-legacy exams, normalize using the config object.
      // For legacy exams (no config), retain the existing shape.
      if (config) {
        const normalized = {
          ...rawData,
          // Basic metadata from config
          title: config?.title ?? rawData?.title,
          description: config?.description ?? rawData?.description,
          instruction: config?.instructions ?? rawData?.instruction,
          duration: config?.duration ?? rawData?.duration,
          // Subject
          subject: config?.subject || rawData?.subject,
          // Session / term normalized to match existing UI shape
          session: config?.session
            ? { session: config.session.name, id: config.session.id }
            : rawData?.session,
          term: config?.term
            ? { term: config.term.name, id: config.term.id }
            : rawData?.term,
          // Creator and classes
          created_by: config?.created_by || rawData?.created_by,
          classes: Array.isArray(config?.classes) && config.classes.length > 0
            ? config.classes
            : rawData?.classes,
          // Status from root or config so it always displays
          status: rawData?.status ?? config?.status,
          total_grade: config?.total_grade ?? rawData?.total_grade,
          config
        };

        setSchoolExamData(normalized);
        setQuestionArr(Array.isArray(normalized?.questions) && normalized.questions.length > 0 ? normalized.questions : []);
        const scheduleSplit = loadScheduleOffFieldsFromApi(config || {}, rawData || {});
        setMetadataForm({
          title: config?.title ?? rawData?.title ?? "",
          description: config?.description ?? rawData?.description ?? "",
          instruction: config?.instructions ?? rawData?.instruction ?? "",
          duration: config?.duration ?? rawData?.duration ?? 0,
          total_grade: config?.total_grade ?? rawData?.total_grade ?? 0,
          time_per_question: config?.max_time_per_question ?? "",
          exam_date: scheduleSplit.exam_date,
          start_time: scheduleSplit.start_time,
          end_time: scheduleSplit.end_time,
          use_exam_schedule: typeof config?.use_exam_schedule === "boolean" ? config.use_exam_schedule : true,
          random_question: config?.randomize_questions ? "yes" : "no",
          random_options: config?.randomize_options ? "yes" : "no",
          display_score_after_exam: config?.display_score_after_exam ? "yes" : "no",
          question_display_mode: config?.questions_display_mode === "one_per_page" ? "one" : "all",
          proctoring_requirements: config?.proctoring_requirements?.level ?? "",
          browser_lockdown: !!config?.browser_lockdown_settings
        });
      } else {
        setSchoolExamData(rawData);
        setQuestionArr(Array.isArray(rawData?.questions) && rawData.questions.length > 0 ? rawData.questions : []);
        const fallbackSplit = loadScheduleOffFieldsFromApi(rawData || {}, {});
        setMetadataForm((prev) => ({
          ...prev,
          title: rawData?.title ?? prev.title,
          description: rawData?.description ?? prev.description,
          instruction: rawData?.instruction ?? prev.instruction,
          duration: rawData?.duration ?? prev.duration,
          total_grade: rawData?.total_grade ?? prev.total_grade,
          exam_date: fallbackSplit.exam_date || prev.exam_date,
          start_time: fallbackSplit.start_time || prev.start_time,
          end_time: fallbackSplit.end_time || prev.end_time
        }));
      }
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const buildEditQuestionsPayload = () => editQuestionArr.map((q) => {
    const optionValues = (q.options || []).map((opt) => {
      if (typeof opt === "object" && opt !== null && (opt?.file_url || opt?.text != null)) {
        const textVal = opt?.text != null && opt.text !== "" ? opt.text : null;
        const fileVal = opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : null;

        return textVal ?? fileVal ?? opt;
      }

      return opt;
    });
    const item = {
      type: q.type,
      question_text: (q.question_text || "").trim(),
      options: optionValues,
      answer: Array.isArray(q.answer) ? q.answer : [],
      grade_point: Number(q.grade_point) || 0
    };
    if (q.id) item.id = q.id;
    if (q.add_to_bank) item.add_to_bank = true;

    return item;
  });

  const handleUpdateExamQuestions = (nextStatus, endpointType = "config_questions") => {
    if (!editQuestionsValidator.allValid()) {
      showEditQuestionsValidator(true);

      return;
    }
    const configId = schoolExamData?.config?.id ?? id;
    /** Exam resource id from route — same as GET /api/v1/exams/:id */
    const examResourceId = id;
    if (endpointType === "exam_root") {
      setIsPublishingQuestions(true);
    } else {
      setIsUpdatingDraftQuestions(true);
    }
    const questionsPayload = buildEditQuestionsPayload();
    const body = { status: nextStatus, questions: questionsPayload };
    const url = endpointType === "exam_root"
      ? `${isTeacher ? "/api/v1/school-exams" : "/api/v1/exams"}/${examResourceId}`
      : `${EXAM_CONFIG_ENDPOINT}/${configId}/questions`;
    const request = nextStatus === "draft"
      ? httprequest.patch(url, { questions: questionsPayload })
      : httprequest.post(url, body);

    request
      .then(() => {
        setIsUpdatingDraftQuestions(false);
        setIsPublishingQuestions(false);
        toast.success("Questions updated successfully.");
        setIsEditQuestionsModalOpen(false);
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        setIsUpdatingDraftQuestions(false);
        setIsPublishingQuestions(false);
        toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to update questions.");
      });
  };

  useEffect(() => {
    getExamAttendees();
  }, []);

  useEffect(() => {
    if (value === "1") {
      getEnrolmentExaminationById();
    }
  }, [value]);

  /**
 * Exports examination data to a Word document
 */
  const exportToWord = () => {
    if (!schoolExamData || !schoolExamData.questions) {
      toast.error("No exam data available.");

      return;
    }

    let htmlContent = `
      <h1>${schoolExamData.title || "School Examination"}</h1>
      <p><strong>Created By:</strong> ${schoolExamData?.created_by?.name || ""}</p>
      <p><strong>Subject:</strong> ${schoolExamData?.subject?.name || "--/--"}</p>
      <p><strong>Total Grade:</strong> ${schoolExamData?.total_grade || "--/--"}</p>
      <p><strong>Duration:</strong> ${schoolExamData?.duration || "--/--"} mins</p>
      <hr />
      <h2>Questions:</h2>
    `;

    schoolExamData.questions.forEach((question, idx) => {
      const qText = (question.question_text || question.question || "").trim();
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <h3>Q${questionDisplayIndex(question, idx, schoolExamData.questions)}: ${qText}</h3>
          ${question?.file?.file_url ? `<img src="${question.file.file_url}" width="200"/>` : ""}
          <ul>
            ${question.options.map((option) => {
    const content = typeof option === "object" && option?.file_url
      ? `<img src="${option.file_url}" width="150"/>`
      : option;

    return `<li>${content}</li>`;
  }).join("")}
          </ul>
        </div>
      `;
    });

    const blob = HTMLDocx.asBlob(htmlContent);
    saveAs(blob, `${schoolExamData.subject.name} ${schoolExamData.title || "exam"}.docx`);
    setIsExportModalOpen(false);
    toast.success("Examination Exported successfully");
  };

  /**
   * Export all exam questions to CSV (same columns as batch import template).
   */
  const exportQuestionsToCsv = () => {
    const questions = schoolExamData?.questions;
    if (!questions?.length) {
      toast.error("No questions to export.");

      return;
    }

    const optionText = (opt) => {
      if (opt == null) return "";
      if (typeof opt === "object") return opt?.text != null && opt.text !== "" ? String(opt.text) : (opt?.file_url ? "[image]" : "");

      return String(opt);
    };

    const rows = questions.map((q) => {
      const texts = (q.options || []).map(optionText);
      const optionsStr = texts.join(",");
      const type = q.type || "multiple_choice";
      const answers = Array.isArray(q.answer) ? q.answer : [];
      let answerStr = "";
      if (type === "checkbox") {
        answerStr = answers.map((i) => texts[i]).filter(Boolean).join(",");
      } else {
        const idx = answers[0];
        answerStr = "";
        if (typeof idx === "number" && idx >= 0 && idx < texts.length) {
          const t = texts[idx];
          if (t !== "" && t != null) {
            answerStr = String(t);
          }
        }
      }

      return {
        questions: q.question_text || q.question || "",
        description: q.description ?? "",
        answer_type: type,
        options: optionsStr,
        answer: answerStr,
        question_bank: q.add_to_bank ? "true" : "false",
        question_point: q.grade_point != null ? String(q.grade_point) : ""
      };
    });

    const csv = Papa.unparse(rows, { columns: ["questions", "description", "answer_type", "options", "answer", "question_bank", "question_point"] });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const safeTitle = (schoolExamData?.title || "exam").replace(/[/\\?%*:|"<>]/g, "-");
    const safeSubject = (schoolExamData?.subject?.name || "questions").replace(/[/\\?%*:|"<>]/g, "-");
    saveAs(blob, `${safeSubject}_${safeTitle}_questions.csv`);
    toast.success("Questions exported to CSV.");
  };

  /**
 * Toggles the export modal visibility
 */
  const handleExportModalToggle = () => {
    setIsExportModalOpen(!isExportModalOpen);
  };

  const handleBatchImportModalToggle = () => {
    setIsBatchImportModalOpen(!isBatchImportModalOpen);
  };

  /**
   * Normalizes a raw row key (handles questions/question and trim/lowercase).
   */
  const getRowVal = (row, key) => {
    const k = key.toLowerCase().trim();
    const keys = Object.keys(row || {}).map((x) => x.toLowerCase().trim());
    const idx = keys.indexOf(k);
    if (idx === -1) {
      let missing;

      return missing;
    }
    const actualKey = Object.keys(row)[idx];
    const v = row[actualKey];

    return typeof v === "string" ? v.trim() : v;
  };

  /**
   * Maps a parsed row (CSV/Excel) to the question shape used by the Add question modal.
   * Columns: questions, description, answer_type, options, answer, question_bank, question_point.
   */
  const mapRowToQuestion = (row, questionIndex) => {
    const questionText = getRowVal(row, "questions") ?? getRowVal(row, "question") ?? "";
    const description = getRowVal(row, "description");
    const answerType = String(getRowVal(row, "answer_type") ?? "multiple_choice").toLowerCase();
    const type = answerType === "checkbox" ? "checkbox" : "multiple_choice";
    const optionsStr = String(getRowVal(row, "options") ?? "");
    const baseOptions = optionsStr ? optionsStr.split(",").map((s) => s.trim()).filter(Boolean) : [];
    const answerStr = String(getRowVal(row, "answer") ?? "");
    const questionBankRaw = getRowVal(row, "question_bank");
    const questionBankStr = String(questionBankRaw ?? "false").toLowerCase();
    const add_to_bank = questionBankRaw === true || questionBankStr === "true" || questionBankStr === "1" || questionBankStr === "yes";
    const gradePointRaw = getRowVal(row, "question_point") ?? getRowVal(row, "grade_point") ?? 1;
    const grade_point = Number(gradePointRaw) || 1;

    const answerParts = answerStr ? answerStr.split(",").map((s) => s.trim()).filter(Boolean) : [];

    // Merge answer values into options if not already present
    const allOptions = [...baseOptions];
    if (type === "checkbox") {
      answerParts.forEach((part) => {
        if (!allOptions.includes(part)) allOptions.push(part);
      });
    } else {
      const firstAnswer = answerParts[0] ?? "";
      if (firstAnswer && !allOptions.includes(firstAnswer)) allOptions.push(firstAnswer);
    }

    // Resolve answer indices from the merged options list
    let answer = [];
    if (allOptions.length > 0 && answerParts.length > 0) {
      if (type === "checkbox") {
        answer = answerParts
          .map((part) => allOptions.findIndex((opt) => opt === part))
          .filter((i) => i >= 0);
      } else {
        const idx = allOptions.findIndex((opt) => opt === (answerParts[0] ?? ""));
        if (idx >= 0) answer = [idx];
      }
    }

    const q = {
      question_text: questionText,
      file: {},
      question_index: questionIndex + 1,
      type,
      grade_point,
      answer,
      required: false,
      add_to_bank,
      options: allOptions.length ? allOptions : [""]
    };
    if (description != null && description !== "") q.description = description;

    return q;
  };

  /**
   * Parses CSV or Excel file and returns array of row objects.
   */
  const parseBatchFile = (file, fileType) => {
    return new Promise((resolve, reject) => {
      if (fileType === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const result = Papa.parse(e.target?.result ?? "", { header: true, skipEmptyLines: true });
            resolve(result?.data ?? []);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.readAsText(file);
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target?.result);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
            resolve(Array.isArray(rows) ? rows : []);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.readAsArrayBuffer(file);
      }
    });
  };

  /**
   * Handles batch import: parses CSV/Excel, maps to questions, opens Add question modal.
   */
  const handleBatchImportQuestions = async (file) => {
    setIsBatchImportLoading(true);
    try {
      const rows = await parseBatchFile(file, batchFileType);
      // eslint-disable-next-line no-console
      console.log("[BatchImport] Raw rows from file:", JSON.stringify(rows, null, 2));
      if (!rows?.length) {
        toast.error("No rows found in the file.");

        return;
      }
      const mapped = rows.map((row, i) => mapRowToQuestion(row, i));
      // eslint-disable-next-line no-console
      console.log("[BatchImport] Mapped questions:", JSON.stringify(mapped, null, 2));
      setQuestionArr(mapped);
      setSchoolExamForm((prev) => ({ ...prev, questions: mapped }));
      setIsBatchImportModalOpen(false);
      setIsAddQuestionModalOpen(true);
    } catch (err) {
      toast.error(err?.message ?? "Failed to parse file.");
    } finally {
      setIsBatchImportLoading(false);
    }
  };

  const handleOpenAddQuestionModal = () => {
    if ((questionArr?.length ?? 0) === 0) {
      const initialQuestion = {
        question_text: "",
        file: {},
        question_index: 1,
        type: "",
        grade_point: 0,
        answer: "",
        required: false,
        add_to_bank: false,
        options: []
      };
      setQuestionArr([initialQuestion]);
      setSchoolExamForm((prev) => ({ ...prev, questions: [initialQuestion] }));
    }
    setIsAddQuestionModalOpen(true);
  };

  /** Normalize API question to form shape for edit modal */
  const normalizeQuestionForForm = (q) => ({
    question_text: q?.question_text ?? q?.question ?? "",
    type: q?.type ?? "",
    options: Array.isArray(q?.options) ? q.options.map((o) => (typeof o === "object" && o !== null && (o?.file_url || o?.text != null) ? o : (typeof o === "string" ? o : ""))) : [""],
    answer: Array.isArray(q?.answer) ? q.answer : (q?.answer != null ? [q.answer] : []),
    grade_point: q?.grade_point ?? 0,
    id: q?.id ?? null,
    file: q?.file ?? {},
    add_to_bank: q?.add_to_bank ?? false,
    required: q?.required ?? false,
    question_index: q?.question_index ?? 0
  });

  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data || []);
      })
      .catch(() => {});
  };

  const getAllTerms = (sessionId) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        const terms = res?.data?.data || [];
        if (!sessionId) {
          setAllTerms([]);

          return;
        }
        setAllTerms(terms.filter((sessionTerm) => sessionTerm?.session_id === sessionId));
      })
      .catch(() => {});
  };

  const getAllTeacherClasses = () => {
    httprequest
      .get(TEACHER_CLASS_ENDPOINT)
      .then((res) => {
        setClassData((res?.data?.data || []).map((clss) => ({
          class_name: clss?.class?.name,
          id: clss?.class?.id
        })));
      })
      .catch(() => {});
  };

  const getAllAdminClasses = () => {
    const ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : ADMIN_CLASS_ENDPOINT;
    httprequest
      .get(ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data || []);
      })
      .catch(() => {});
  };

  const getSubjectsForClasses = async (classValues) => {
    try {
      if (!classValues || classValues.length === 0) {
        setAllClassSubject([]);
        setMetadataForm((prev) => ({ ...prev, subject_id: "" }));

        return;
      }

      let intersectedSubjects = null;

      for (const { id: classId } of classValues) {
        const SUBJECT_ENDPOINT = isTeacher ? TEACHER_SUBJECT_FOR_CLASS_ENDPOINT : CLASS_SUBJECT_ENDPOINT;
        const res = await httprequest.get(`${SUBJECT_ENDPOINT}${classId}`);
        const classSubjects = res?.data?.data || [];

        const normalized = classSubjects.map((sub) => {
          if (isTeacher) {
            return {
              subject_id: sub?.subject?.id,
              subject: sub?.subject,
              displayName: sub?.subject?.name
            };
          }

          return {
            subject_id: sub?.subject_id,
            subject_name: sub?.subject_name,
            displayName: sub?.subject_name
          };
        });

        if (intersectedSubjects === null) {
          intersectedSubjects = normalized;
        } else {
          intersectedSubjects = intersectedSubjects.filter((existing) => normalized.some((newSub) => newSub.subject_id === existing.subject_id));
        }
      }

      const newSubjects = intersectedSubjects || [];
      setAllClassSubject(newSubjects);
      const availableSubjectIds = newSubjects.map((subject) => isTeacher ? subject?.subject?.id : subject?.subject_id);
      setMetadataForm((prev) => ({
        ...prev,
        subject_id: availableSubjectIds.includes(prev.subject_id) ? prev.subject_id : ""
      }));
    } catch (err) {
      toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to fetch subjects.");
    }
  };

  const handleOpenEditQuestionsModal = () => {
    const source = schoolExamData?.questions?.length > 0 ? schoolExamData.questions : questionArr;
    const normalized = (source?.length > 0 ? source : []).map(normalizeQuestionForForm);
    setEditQuestionArr(normalized.length > 0 ? normalized : [{
      question_text: "",
      type: "",
      options: [""],
      answer: [],
      grade_point: 0,
      id: null,
      file: {},
      add_to_bank: false,
      required: false,
      question_index: 1
    }]);
    setIsEditQuestionsModalOpen(true);
  };

  const handleOpenMetadataDrawer = () => {
    const config = schoolExamData?.config;
    const existingClasses = (schoolExamData?.classes || []).map((classItem) => ({
      id: classItem?.id,
      name: classItem?.name
    })).filter((classItem) => classItem?.id);
    const initialSessionId = config?.session_id ?? schoolExamData?.session?.id ?? schoolExamData?.session_id ?? schoolExamData?.term?.session_id ?? "";
    const drawerScheduleSplit = loadScheduleOffFieldsFromApi(config || {}, schoolExamData || {});
    const newForm = {
      class_id: existingClasses,
      subject_id: config?.subject_id ?? schoolExamData?.subject?.id ?? schoolExamData?.subject_id ?? "",
      session_id: initialSessionId,
      term_id: config?.term_id ?? schoolExamData?.term?.id ?? schoolExamData?.term_id ?? "",
      title: config?.title ?? schoolExamData?.title ?? "",
      description: config?.description ?? schoolExamData?.description ?? "",
      instruction: config?.instructions ?? schoolExamData?.instruction ?? "",
      duration: config?.duration ?? schoolExamData?.duration ?? 0,
      total_grade: config?.total_grade ?? schoolExamData?.total_grade ?? 0,
      time_per_question: config?.max_time_per_question ?? "",
      exam_date: drawerScheduleSplit.exam_date,
      start_time: drawerScheduleSplit.start_time,
      end_time: drawerScheduleSplit.end_time,
      use_exam_schedule: typeof config?.use_exam_schedule === "boolean" ? config.use_exam_schedule : true,
      random_question: config?.randomize_questions ? "yes" : "no",
      random_options: config?.randomize_options ? "yes" : "no",
      display_score_after_exam: config?.display_score_after_exam ? "yes" : "no",
      question_display_mode: config?.questions_display_mode === "one_per_page" ? "one" : "all",
      proctoring_requirements: config?.proctoring_requirements?.level ?? "",
      browser_lockdown: !!config?.browser_lockdown_settings,
      is_private: config?.is_private ?? schoolExamData?.is_private ?? false
    };
    setMetadataForm(newForm);
    setInitialMetadataForm(newForm);
    if (existingClasses.length > 0) {
      getSubjectsForClasses(existingClasses);
    } else {
      setAllClassSubject([]);
    }
    getAllTerms(initialSessionId);
    setIsMetadataDrawerOpen(true);
  };

  useEffect(() => {
    const shouldOpen = searchParams.has("editConfig");
    if (shouldOpen && !isMetadataDrawerOpen && schoolExamData && Object.keys(schoolExamData).length > 0) {
      handleOpenMetadataDrawer();
    }
  }, [searchParams, schoolExamData, isMetadataDrawerOpen]);

  useEffect(() => {
    if (isTeacher) {
      getAllTeacherClasses();
    } else {
      getAllAdminClasses();
    }
    getAllSession();
  }, [isTeacher]);

  const buildSearchWithEditConfig = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const base = params.toString();

    return base ? `?${base}&editConfig` : "?editConfig";
  };

  const handleCloseMetadataDrawer = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const nextSearch = params.toString();
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : "" });
    setIsMetadataDrawerOpen(false);
  };

  const handleMetadataClassChange = (selectedOptions) => {
    const selectedValues = (selectedOptions || []).map((option) => ({
      id: option?.id ?? option?.value,
      name: option?.name ?? option?.label
    })).filter((classItem) => classItem?.id);
    setMetadataForm((prev) => ({
      ...prev,
      class_id: selectedValues,
      subject_id: ""
    }));
    if (selectedValues.length > 0) {
      getSubjectsForClasses(selectedValues);
    } else {
      setAllClassSubject([]);
    }
  };

  const handleMetadataChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "session_id") {
      setMetadataForm((prev) => ({
        ...prev,
        session_id: value,
        term_id: ""
      }));
      getAllTerms(value);

      return;
    }
    setMetadataForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const isMetadataDurationValid = () => {
    const d = metadataForm.duration;
    if (d === "" || d === null || typeof d === "undefined") {
      return false;
    }
    const num = Number(d);

    return !Number.isNaN(num) && num > 0;
  };

  const buildMetadataPatchPayload = () => {
    const durationNum = Number(metadataForm.duration);
    const questionsDisplayMode = metadataForm.question_display_mode === "one"
      ? "one_per_page"
      : "all_at_once";

    const totalGradeNum = Number(metadataForm.total_grade);
    const useSchedule = !!metadataForm.use_exam_schedule;

    return {
      class_id: (metadataForm.class_id || []).map((classItem) => classItem?.id).filter(Boolean),
      subject_id: metadataForm.subject_id || null,
      session_id: metadataForm.session_id || null,
      term_id: metadataForm.term_id || null,
      title: metadataForm.title?.trim() ?? "",
      description: metadataForm.description ?? "",
      instructions: metadataForm.instruction ?? "",
      duration: Number.isNaN(durationNum) ? 0 : durationNum,
      total_grade: Number.isNaN(totalGradeNum) ? 0 : totalGradeNum,
      randomize_questions: metadataForm.random_question === "yes",
      randomize_options: metadataForm.random_options === "yes",
      questions_display_mode: questionsDisplayMode,
      display_score_after_exam: metadataForm.display_score_after_exam === "yes",
      use_exam_schedule: useSchedule,
      start_date: useSchedule ? null : (metadataForm.exam_date || null),
      start_time: useSchedule ? null : formatTimeForApi(metadataForm.start_time),
      end_time: useSchedule ? null : formatTimeForApi(metadataForm.end_time),
      max_time_per_question: metadataForm.time_per_question ? Number(metadataForm.time_per_question) : null,
      proctoring_requirements: metadataForm.proctoring_requirements
        ? { level: metadataForm.proctoring_requirements }
        : {},
      browser_lockdown_settings: metadataForm.browser_lockdown ? {} : null,
      is_private: !!metadataForm.is_private
    };
  };

  const handleSaveMetadata = () => {
    const titleValid = metadataForm.title?.trim();
    if (!titleValid) {
      showCreateExamValidator(true);
      toast.error("Exam title is required.");

      return;
    }
    if (!isMetadataDurationValid()) {
      showCreateExamValidator(true);
      toast.error("Exam duration is required and must be a positive number (minutes).");

      return;
    }
    if (!metadataForm.use_exam_schedule) {
      const hasDateTime = metadataForm.exam_date && metadataForm.start_time && metadataForm.end_time;
      if (!hasDateTime) {
        showCreateExamValidator(true);
        toast.error("Exam date, start time, and end time are required when Use Exam Schedule is off.");

        return;
      }
      if (!isExamEndAfterStart(metadataForm.exam_date, metadataForm.start_time, metadataForm.end_time)) {
        toast.error("Start time must be before end time.");

        return;
      }
    }
    const configId = schoolExamData?.config?.id;
    if (!configId) {
      toast.error("Exam config not found. Cannot update.");

      return;
    }
    const payload = buildMetadataPatchPayload();
    httprequest
      .patch(`${EXAM_CONFIG_ENDPOINT}/${configId}`, payload)
      .then(() => {
        toast.success("Exam details updated successfully.");
        handleCloseMetadataDrawer();
        getEnrolmentExaminationById();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to update exam details.");
      });
  };

  const hasQuestions = (schoolExamData?.questions?.length > 0) || (questionArr?.length > 0);
  const shouldHideScheduleDates = schoolExamData?.config?.use_exam_schedule === true;

  /**
 * A list of available question types for an assignment form.
 * Each option includes a value (used internally), a text label (shown to users), and an icon (React component).
 * Some options are commented out and can be enabled as needed.
 *
 * @type {Array<{value: string, text: string, icon: JSX.Element}>}
 */
  const options = [
    // {
    //   value: "paragraph",
    //   text: "Paragraph",
    //   icon: <Icon icon="carbon:text-short-paragraph" width="25" height="25" />
    // },
    {
      value: "multiple_choice",
      text: "Multiple Choice",
      icon: <Icon icon="mdi:radiobox-marked" width="25" height="25" />
    },
    {
      value: "true_false",
      text: "True / False",
      icon: <Icon icon="mdi:toggle-switch-outline" width="25" height="25" />
    },
    {
      value: "checkbox",
      text: "Checkbox",
      icon: <Icon icon="ci:checkbox-check" width="25" height="25" />
    }
    // {
    //   value: "dropdown",
    //   text: "Dropdown",
    //   icon: <Icon icon="tabler:select" width="25" height="25" />
    // },
    // {
    //   value: "file_upload",
    //   text: "File Upload",
    //   icon: <Icon icon="basil:cloud-upload-outline" width="25" height="25" />
    // },
    // {
    //   value: "date",
    //   text: "Date",
    //   icon: (
    //     <Icon
    //       icon="material-symbols-light:date-range-sharp"
    //       width="25"
    //       height="25"
    //     />
    //   )
    // },
    // {
    //   value: "time",
    //   text: "Time",
    //   icon: <Icon icon="mingcute:time-line" width="25" height="25" />
    // }
  ];

  function renderQuestionBuilder() {
    return (
      <>
        <div className="margin-top">
          <Grid container spacing={2}>
            {questionArr?.map((que, queInd) => (
              <>
                <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
                  <div className={`${styles.assignmentsection}`}>
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className={styles.quesaction}>
                          <label className={styles.quelabel}>Enter Question  {queInd + 1}</label>
                          <div>
                            {questionArr?.length > 1 ? (
                              <>
                                <Icon
                                  icon="material-symbols:delete-outline"
                                  width="20"
                                  height="20"
                                  className="delete-icon"
                                  onClick={() => removeAdditionalQue(queInd)}
                                />
                              </>
                            ) : null}
                          </div>
                        </div>
                        <div className={styles.textandimgmain}>
                          <div className={styles.textandimg}>
                            <input
                              type="text"
                              placeholder={questionImages[queInd] ? "" : "Type Question"}
                              name="question_text"
                              value={que?.question_text}
                              onChange={(e) => {
                                handleQueChange(e, queInd);
                              }}
                            />
                            {createExamValidator.message(
                              "question",
                              questionArr[queInd]["question_text"],
                              "required"
                            )}
                            <div onClick={() => handleIconClick(queInd)} className={styles.queimg}>
                              <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                              <input
                                type="file"
                                accept="image/*"
                                id={`imageInput-${queInd}`}
                                multiple
                                onChange={(e) => handleQuestionImageChange(e, queInd)}
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className={styles.preiewcont}>
                              {questionImages[queInd] && (
                                <>
                                  <img
                                    src={questionImages[queInd]}
                                    alt={`Selected for question ${queInd}`}
                                  />
                                  <Icon
                                    icon="material-symbols:delete-outline"
                                    width="20"
                                    height="20"
                                    className="delete-icon"
                                    onClick={() => removeQueImage(queInd)}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <SelectGroup
                          label="Add Answer Type"
                          required
                          children={
                            <select
                              name="type"
                              value={que?.type}
                              onChange={(e) => handleQueTypeChange(e, queInd)}
                            >
                              <option value="">--- Select ---</option>
                              {options?.map((label) => (
                                <option key={label?.key} value={label?.value}>
                                  <Icon className={`${styles.add_question_color}`} icon="flat-color-icons:plus" width="24" height="24" />
                                  {label?.text}
                                </option>
                              ))}
                            </select>
                          }
                        />
                        {createExamValidator.message("question type", questionArr[queInd]["type"], "required")}
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <InputGroup
                          className={styles.pointsInput}
                          label="Question Point"
                          inputType="number"
                          inputName="grade_point"
                          placeHolder="Enter Question Points"
                          value={que?.grade_point}
                          onChange={(e) => handleQuePointChange(e, queInd)}
                        />
                        {createExamValidator.message("points", questionArr[queInd]?.grade_point, "required")}
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        {"description" in que ? (
                          <div className="margin-top full-width">
                            <div className=" flex gap-10 justify-items-space">
                              <label className={styles.enterque}>Question Description</label>
                              <div>
                                <div className="delete-icon" onClick={() => removeQueDescription(queInd)}>
                                  <Icon icon="ooui:close" width="20" height="20" />
                                </div>
                              </div>
                            </div>
                            <div className={styles.textandimgmain}>
                              <div className={styles.textandimg}>
                                <input
                                  type="text"
                                  placeHolder="Enter Description"
                                  name="description"
                                  value={que?.description}
                                  onChange={(e) => handleQueDescChange(e, queInd)}
                                />
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </Grid>
                    </Grid>
                    {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                      <Grid container spacing={2} sx={{ marginTop: 1 }}>
                        {(que?.options || []).map((opt, i) => (
                          <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                            <div>
                              <div className=" flex gap-10 justify-items-space">
                                <label className={styles.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                                {que?.options?.length > 1 && que?.type !== "true_false" ? (
                                  <Icon onClick={() => removeAdditionalChoice(i, queInd)} className="delete-icon" icon="ooui:close" width="20" height="20" />
                                ) : null}
                              </div>
                              <div className={styles.textandimgmain}>
                                <div className={styles.textandimg}>
                                  <input
                                    type="text"
                                    placeholder="Enter option"
                                    value={typeof opt === "object" ? opt?.text : opt}
                                    disabled={que?.type === "true_false" || disabledInputs[queInd]?.[i]}
                                    onChange={(e) => handleMultipleChoiceChange(e, i, queInd)}
                                  />
                                  {que?.type !== "true_false" && (
                                    <>
                                      <div onClick={() => handleIconOptionClick(i, queInd)} className={styles.queimg}>
                                        <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                        <input
                                          type="file"
                                          accept="image/*"
                                          id={`imageInput-${i}${queInd}`}
                                          onChange={(e) => handleOptionImageChange(e, i, queInd)}
                                          style={{ display: "none" }}
                                        />
                                      </div>
                                      <div className={styles.preiewoptioncont}>
                                        {optionimages[`${queInd}-${i}`] && optionimages[`${queInd}-${i}`] !== "" && (
                                          <>
                                            <img src={optionimages[`${queInd}-${i}`]} alt={`Option ${i + 1}`} />
                                            <Icon icon="material-symbols:delete-outline" width="20" height="20" className="delete-icon" onClick={() => removeOptionImage(i, queInd)} />
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="text-align-left" style={{ marginTop: 5 }}>
                                <div className={styles.correctcontainer}>
                                  <input
                                    type={que?.type === "checkbox" ? "checkbox" : "radio"}
                                    name={que?.type === "checkbox" ? `answer-checkbox-${queInd}` : `answer-${queInd}`}
                                    value={i}
                                    checked={que?.type === "checkbox" ? (que?.answer || []).includes(i) : (que?.answer || [])[0] === i}
                                    onChange={(e) => handleCorrectChoiceChange(e, i, queInd)}
                                  />
                                  <label className={styles.correctlabel} htmlFor="Is Correct">is correct</label>
                                </div>
                                {createExamValidator.message(`question ${queInd + 1} answer`, questionArr[queInd]["answer"]?.length > 0 ? questionArr[queInd]["answer"] : null, "required")}
                              </div>
                            </div>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {que?.type === "multiple_choice" && (
                      <div className={styles.addoption} onClick={() => handleAdditionalOptions(queInd)}>
                        <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                        <p>Add another option</p>
                      </div>
                    )}
                    {que?.type === "checkbox" && (
                      <div className={styles.addoption} onClick={() => handleAdditionalOptions(queInd)}>
                        <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                        <p>Add another checkbox</p>
                      </div>
                    )}
                    <div className={styles.questionfooter}>
                      <div className="flex gap-10 align-items-center justifyRight">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!questionArr[queInd]?.add_to_bank}
                              onChange={(e) => {
                                const newQuestionArr = [...questionArr];
                                newQuestionArr[queInd] = { ...newQuestionArr[queInd], add_to_bank: e.target.checked };
                                setQuestionArr(newQuestionArr);
                                setSchoolExamForm({ ...schoolExaminationForm, questions: newQuestionArr });
                              }}
                              size="small"
                            />
                          }
                          label="Add to Question Bank"
                          sx={{ marginRight: 1 }}
                        />
                        {!que?.description && (
                          <IconButton
                            aria-label="more"
                            onClick={(e) => handleClick(e, queInd)}
                          >
                            <Icon icon="radix-icons:dots-vertical" width="20" height="20" />
                            <label className={styles.enterque}>More</label>
                          </IconButton>
                        )}
                      </div>
                    </div>
                    <Menu anchorEl={anchorEl} open={open} onClose={handleAdditionalQueClose}>
                      <MenuItem
                        onClick={() => {
                          toggleQueDescriptionTrue();
                          handleAdditionalQueClose();
                        }}
                      >
                        Add Description on Question
                      </MenuItem>
                    </Menu>
                  </div>
                </Grid>
              </>
            ))}
          </Grid>
        </div>
        <div className={styles.addque}>
          <Icon icon="octicon:feed-plus-16" width="16" height="16" />
          <p onClick={handleAdditionalQuestion}>Add question</p>
        </div>
        <div>
          <div className={styles.btnwrapper}>
            <Button
              variant="primaryoutline"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btnfontprimary"
              isLoading={isDrafting}
              onClick={handleCreateDraftExam}
              buttonName="Save as Draft"
            />
            <Button
              variant="primary"
              buttonSize={isSmallScreen ? "full" : "fluid"}
              color="btndefault"
              buttonName="Publish Examination"
              isLoading={isCreating}
              onClick={handleCreateExam}
            />
          </div>
        </div>
      </>
    );
  }

  const examStatus = schoolExamData?.status ?? schoolExamData?.config?.status;
  const isPublishedExam = examStatus === "published";
  const isSchoolExamExpired = examStatus === "expired";
  const examConfigId = schoolExamData?.config?.id ?? id;
  const lessonOutlineFromState = location.state?.lessonOutline;

  const renderExamActionIcons = ({ showAddQuestion = true } = {}) => (
    <div className={classes.actionIconGroup}>
      {!isPublishedExam && (
        <Tooltip title="Batch Import" arrow placement="top">
          <button
            type="button"
            className={classes.exportIconBtn}
            onClick={handleBatchImportModalToggle}
            aria-label="Batch Import"
          >
            <Icon icon="mdi:tray-arrow-up" width="22" height="22" />
          </button>
        </Tooltip>
      )}
      {showAddQuestion && !isPublishedExam && (
        <Tooltip title="Add question" arrow placement="top">
          <button
            type="button"
            className={classes.editIconBtn}
            onClick={handleOpenAddQuestionModal}
            aria-label="Add question"
          >
            <Icon icon="mdi:plus" width="22" height="22" />
          </button>
        </Tooltip>
      )}
      <Tooltip title="Export" arrow placement="top">
        <button
          type="button"
          className={classes.exportIconBtn}
          onClick={(e) => setExportMenuAnchor(e.currentTarget)}
          aria-label="Export"
        >
          <Icon icon="flowbite:file-export-outline" width="22" height="22" />
        </button>
      </Tooltip>
      <Menu
        anchorEl={exportMenuAnchor}
        open={Boolean(exportMenuAnchor)}
        onClose={() => setExportMenuAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setExportMenuAnchor(null);
            handleExportModalToggle();
          }}
        >
          Export to Word
        </MenuItem>
        <MenuItem
          onClick={() => {
            setExportMenuAnchor(null);
            exportQuestionsToCsv();
          }}
        >
          Export to CSV
        </MenuItem>
      </Menu>
      <Tooltip title="Edit Exam Config" arrow placement="top">
        <button
          type="button"
          className={classes.exportIconBtn}
          onClick={() => navigate({ pathname: location.pathname, search: buildSearchWithEditConfig() })}
          aria-label="Edit Exam Config"
        >
          <Icon icon="fluent:edit-16-regular" width="22" height="22" />
        </button>
      </Tooltip>
      {!isPublishedExam && (
        <Tooltip title="Generate Questions" arrow placement="top">
          <button
            type="button"
            className={classes.editIconBtn}
            onClick={() => setIsGenerateDrawerOpen(true)}
            aria-label="Generate Questions"
          >
            <Icon icon="fluent-color:bot-sparkle-16" width="22" height="22" />
          </button>
        </Tooltip>
      )}
    </div>
  );

  const editModalContentProps = {
    editQuestionArr,
    styles,
    options,
    editQuestionsValidator,
    isSmallScreen,
    isUpdatingDraft: isUpdatingDraftQuestions,
    isPublishing: isPublishingQuestions,
    onQueChange: editHandleQueChange,
    onQueTypeChange: editHandleQueTypeChange,
    onQuePointChange: editHandleQuePointChange,
    onCorrectChoiceChange: editHandleCorrectChoiceChange,
    onMultipleChoiceChange: editHandleMultipleChoiceChange,
    onAdditionalOptions: editHandleAdditionalOptions,
    onAdditionalQuestion: editHandleAdditionalQuestion,
    onRemoveQuestion: removeEditQuestion,
    onRemoveChoice: removeEditChoice,
    onQueDescChange: editHandleQueDescChange,
    onMenuClick: editHandleClick,
    onMenuClose: editHandleMenuClose,
    onToggleDescription: editToggleQueDescriptionTrue,
    onRemoveDescription: editRemoveQueDescription,
    editAnchorEl,
    editMenuOpen,
    onAddToBankChange: (e, queInd) => {
      setEditQuestionArr((prev) => prev.map((q, idx) => (idx === queInd ? { ...q, add_to_bank: e.target.checked } : q)));
    },
    onUpdateDraft: () => handleUpdateExamQuestions("draft", "config_questions"),
    onUpdatePublish: () => handleUpdateExamQuestions(isPublishedExam ? "withdrawn" : "published", "exam_root"),
    publishButtonLabel: isPublishedExam ? "Withdraw" : "Publish Question",
    hideAddQuestionRow: isPublishedExam,
    onQueImageChange: editHandleQuestionImageChange,
    onOptionImageChange: editHandleOptionImageChange,
    onRemoveQueImage: editRemoveQueImage,
    onRemoveOptionImage: editRemoveOptionImage,
    onIconClick: editHandleIconClick,
    onIconOptionClick: editHandleIconOptionClick
  };

  const metadataScheduleWindowMins = getScheduleWindowMinutes(metadataForm.start_time, metadataForm.end_time);
  const metadataScheduleTimesOrderOk = isExamEndAfterStart(
    metadataForm.exam_date,
    metadataForm.start_time,
    metadataForm.end_time
  );
  const scheduleDisplayFields = loadScheduleOffFieldsFromApi(
    schoolExamData?.config || {},
    schoolExamData || {}
  );
  const scheduleDisplayWindowMins = getScheduleWindowMinutes(
    scheduleDisplayFields.start_time,
    scheduleDisplayFields.end_time
  );

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/school-examination/examination"
                link_one_name="Examination"
                active="Create Examination"
                description="Examination Details"
              />
            </div>
          </div>
          <div className="page-content">
            <PageTitle className={classes.inline}
              title="Examination Details"
              subtitle={schoolExamData?.title ? `${schoolExamData.title} • Created by ${schoolExamData?.created_by?.last_name || ""} ${schoolExamData?.created_by?.first_name || ""} | Class: ${schoolExamData?.classes?.map((clss) => clss?.name).join(", ") || "—"}` : "Add and import questions for this exam"}
              button={renderExamActionIcons({ showAddQuestion: !hasQuestions })}
            />
            <TabContext value={value}>
              <div className="tablist-container">
                <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
                  <Tab label="Exam Details" value="1" />
                  <Tab label="Results" value="2" />
                </Tabs>
              </div>
              <TabPanel value="1" className="tabpanel-overide">
                <Grid sx={{ marginLeft: "0px !important", marginTop: "14px" }} container spacing={1}>
                  <div className="key-pair-container">
                    <Grid container spacing={1}>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Exam Title" subtitle={schoolExamData?.title || "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Subject" subtitle={schoolExamData?.subject?.name || "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Class" subtitle={schoolExamData?.classes?.map((c) => c?.name).join(", ") || "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Term" subtitle={schoolExamData?.term?.term || "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Session" subtitle={schoolExamData?.session?.session || "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Total Duration" subtitle={schoolExamData?.duration ? `${schoolExamData.duration} Minutes` : "-----"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Grade Point" subtitle={schoolExamData?.total_grade || totalPoints || 0} />
                      </Grid>
                      {!shouldHideScheduleDates && (
                        <>
                          <Grid item lg={3} md={3} sm={6} xs={12}>
                            <AssignmentDetailText
                              title="Exam Date"
                              subtitle={scheduleDisplayFields.exam_date || "-----"}
                            />
                          </Grid>
                          <Grid item lg={3} md={3} sm={6} xs={12}>
                            <AssignmentDetailText
                              title="Start Time"
                              subtitle={scheduleDisplayFields.start_time || "-----"}
                            />
                          </Grid>
                          <Grid item lg={3} md={3} sm={6} xs={12}>
                            <AssignmentDetailText
                              title="End Time"
                              subtitle={scheduleDisplayFields.end_time || "-----"}
                            />
                          </Grid>
                          <Grid item lg={3} md={3} sm={6} xs={12}>
                            <AssignmentDetailText
                              title="Exam window"
                              subtitle={scheduleDisplayWindowMins != null ? `${scheduleDisplayWindowMins} minutes` : "-----"}
                            />
                          </Grid>
                        </>
                      )}
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <AssignmentDetailText title="Created By" subtitle={schoolExamData?.created_by?.name || "-----"} />
                      </Grid>
                      {/* <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Created at" subtitle={schoolExamData?.created_at?.substring(0, 10) || "-----"} />
                      </Grid> */}
                      {/* <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Total Grade" subtitle={schoolExamData?.total_grade || "-----"} />
                      </Grid> */}
                      {/* <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText title="Updated At" subtitle={schoolExamData?.updated_at?.substring(0, 10) || "-----"} />
                      </Grid> */}
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText
                          title="Status"
                          subtitle={
                            <div className="subtitle-container">
                              {(schoolExamData?.status ?? schoolExamData?.config?.status)
                                ? <Badge status={schoolExamData?.status ?? schoolExamData?.config?.status} />
                                : "-----"}
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <AssignmentDetailText
                          title="Visibility"
                          subtitle={(schoolExamData?.is_private ?? schoolExamData?.config?.is_private) ? "Private" : "Public"}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  {hasQuestions && schoolExamData?.instruction ? (
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ marginTop: 2, textAlign: "left", width: "100%" }}>
                      <WidgetTitle title="Examination Instructions" />
                      <p className="key-pair-name" style={{ marginBottom: 12, fontWeight: 500, color: "#101928", textAlign: "left" }}>
                        Please read the following instructions carefully
                      </p>
                      <ol style={{ margin: 0, paddingLeft: 20, color: "#40444B", fontSize: 14, lineHeight: 1.6, textAlign: "left" }}>
                        {schoolExamData.instruction
                          .split(/\n+/)
                          .filter((line) => line.trim())
                          .map((line, idx) => (
                            <li key={idx} style={{ marginBottom: 8 }}>{line.trim()}</li>
                          ))}
                      </ol>
                    </Grid>
                  ) : null}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {hasQuestions && (
                      <div style={{ marginBottom: 10 }}>
                        <WidgetTitle
                          title="Questions"
                          link={
                            !isPublishedExam ? (
                              <Button
                                variant="primaryoutline"
                                color="btnfontprimary"
                                buttonSize="fluid"
                                onClick={handleOpenEditQuestionsModal}
                                buttonName="Edit questions"
                                disabled={isSchoolExamExpired}
                              />
                            ) : null
                          }
                        />
                      </div>
                    )}
                    {!hasQuestions ? (
                      <div style={{ minHeight: 280, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
                        <NotFounditem
                          img={noexam}
                          title="No question has been added"
                          subtitle="No Examination questions yet"
                        >
                          {renderExamActionIcons()}
                        </NotFounditem>
                      </div>
                    ) : !isAddQuestionModalOpen ? (
                      <>
                        {(() => {
                          const displayQuestions = (schoolExamData?.questions?.length > 0)
                            ? schoolExamData.questions.map((q, i) => ({
                              ...q,
                              question: q.question ?? q.question_text,
                              question_index: q.question_index ?? i + 1,
                              answer: q.answer ?? schoolExamData.questions[i]?.answer ?? []
                            }))
                            : questionArr.map((q, i) => ({
                              question: q.question_text,
                              question_index: i + 1,
                              file: q.file,
                              type: q.type,
                              options: q.options ?? [],
                              required: q.required,
                              answer: Array.isArray(q.answer) ? q.answer : []
                            }));

                          return (
                            <>
                              <Grid container spacing={2}>
                                {displayQuestions?.map((item, i) => {
                                  const hasImageOption = item?.options?.some(option => typeof option === "object" && option.file_url);
                                  const questionAnswer = item?.answer ?? displayQuestions[i]?.answer ?? [];

                                  return (
                                    <Grid item lg={4} md={6} sm={12} xs={12} key={i}>
                                      <div className="question-preview-container">
                                        <h3 className="question-preview-heading">
                                          Question {questionDisplayIndex(item, i, displayQuestions)}
                                        </h3>
                                        <div className={styles.question}>
                                          <h3 className="question-preview-heading">
                                            {item?.question} {item?.required ? <span className="input-required">*</span> : null}
                                            {item?.file?.file_url ? (
                                              <div className={styles.quesdisplay}>
                                                <img src={item?.file?.file_url} alt="" />
                                              </div>
                                            ) : <div className={styles.displaynone} />}
                                          </h3>

                                          {(item?.type === "multiple_choice" || item?.type === "true_false") ? (
                                            hasImageOption ? (
                                              <Grid container spacing={2}>
                                                {item?.options?.map((option, optIdx) => {
                                                  const isImageOption = typeof option === "object" && option.file_url;

                                                  return (
                                                    <Grid item lg={6} md={6} sm={6} xs={12} key={optIdx}>
                                                      <div className="options-preview">
                                                        <input type="radio" checked={questionAnswer?.includes(optIdx)} name={`q-${item?.question_index}`} readOnly disabled />
                                                        {isImageOption ? (
                                                          <div className={styles.optiondisplay}>
                                                            <img src={option.file_url} alt={`Option ${optIdx + 1}`} />
                                                          </div>
                                                        ) : (
                                                          <label>{option}</label>
                                                        )}
                                                      </div>
                                                    </Grid>
                                                  );
                                                })}
                                              </Grid>
                                            ) : (
                                              <>
                                                {item?.options?.map((option, optIdx) => (
                                                  <div key={optIdx} className="options-preview">
                                                    <input type="radio" checked={questionAnswer?.includes(optIdx)} name={`q-${item?.question_index}`} readOnly disabled />
                                                    <label>{option}</label>
                                                  </div>
                                                ))}
                                              </>
                                            )
                                          ) : item?.type === "checkbox" ? (
                                            hasImageOption ? (
                                              <Grid container spacing={2}>
                                                {item?.options?.map((option, optIdx) => {
                                                  const isImageOption = typeof option === "object" && option.file_url;

                                                  return (
                                                    <Grid item lg={6} md={6} sm={6} xs={12} key={optIdx}>
                                                      <div className="options-preview">
                                                        <input type="checkbox" checked={questionAnswer?.includes(optIdx)} name={`q-${item?.question_index}`} readOnly disabled />
                                                        {isImageOption ? (
                                                          <div className={styles.optiondisplay}>
                                                            <img src={option.file_url} alt={`Option ${optIdx + 1}`} />
                                                          </div>
                                                        ) : (
                                                          <label>{option}</label>
                                                        )}
                                                      </div>
                                                    </Grid>
                                                  );
                                                })}
                                              </Grid>
                                            ) : (
                                              <>
                                                {item?.options?.map((option, optIdx) => (
                                                  <div key={optIdx} className="options-preview">
                                                    <input type="checkbox" checked={questionAnswer?.includes(optIdx)} name={`q-${item?.question_index}`} readOnly disabled />
                                                    <label>{option}</label>
                                                  </div>
                                                ))}
                                              </>
                                            )
                                          ) : null}
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </>
                          );
                        })()}
                      </>
                    ) : null}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel sx={{ padding: "0px !important" }} value="2">
                <Table data={attendeeFilter} columns={columns} subHeader={true} pagination subHeaderComponent={
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAssignmentByClass} />
                }
                />
              </TabPanel>
            </TabContext>
            {/* <ToastContainer /> */}
            <Modal
              title="Export to Word"
              subtitle="Are you sure you want to export this examination to Word?"
              modalContent={<p>This will generate a Word document of this Examination.</p>}
              modalFooter={
                <>
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Confirm Export"
                    onClick={exportToWord}
                  />
                </>
              }
              isopen={isExportModalOpen}
              closeModal={handleExportModalToggle}
            />
            <Modal
              title="Batch Import Questions"
              subtitle={
                <div>Create multiple questions at the same time by importing a csv or Excel file.</div>
              }
              modalContent={
                <>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <p className="key-pair-name">1. Choose file type (CSV or Excel) and download the sample file.</p>
                      <p className="key-pair-name">2. Columns: questions, description, answer_type, options, answer, question_bank, question_point.</p>
                      <p className="key-pair-name">3. options = text separated by commas; answer = correct option(s); answer_type = multiple_choice or checkbox; question_bank = true or false; question_point = points for the question (number).</p>
                      <p className="key-pair-name">4. Upload the completed document, then review in the Add questions modal.</p>
                    </Grid>
                    <BulkQuestionImport
                      fileType={batchFileType}
                      onFileTypeChange={setBatchFileType}
                      createClick={(file) => handleBatchImportQuestions(file)}
                      isLoading={isBatchImportLoading}
                      sampleCsvUrl={questionCsvUrl}
                      sampleXlsxUrl={questionsXlsxUrl}
                    />
                  </Grid>
                </>
              }
              modalFooter={<></>}
              isopen={isBatchImportModalOpen}
              closeModal={handleBatchImportModalToggle}
            />
            <Modal
              fullScreen
              title="Add questions"
              subtitle="Add and edit questions, then save as draft or publish examination."
              isopen={isAddQuestionModalOpen}
              closeModal={() => {
                setIsAddQuestionModalOpen(false);
                setQuestionArr([]);
              }}
              modalContent={renderQuestionBuilder()}
              modalFooter={null}
            />
            <Modal
              fullScreen
              title="Edit questions"
              subtitle="Update exam questions. Questions with existing data are prefilled; you can add more or remove questions."
              isopen={isEditQuestionsModalOpen}
              closeModal={() => setIsEditQuestionsModalOpen(false)}
              modalContent={<EditQuestionsModalContent {...editModalContentProps} />}
              modalFooter={null}
            />
            <RightDrawer
              open={isMetadataDrawerOpen}
              onClose={handleCloseMetadataDrawer}
              title="Edit Exam Meta Data"
            >
              <Grid container spacing={2}>
                {/* Academic Settings */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className="full-width margin-top">
                    <label htmlFor="class_id">Class</label>
                    <Select
                      isMulti
                      name="class_id"
                      options={(classData || []).map((cls) => ({
                        value: cls?.id ?? cls?.class?.id,
                        label: cls?.class_name ?? cls?.name ?? cls?.class?.name,
                        id: cls?.id ?? cls?.class?.id,
                        name: cls?.class_name ?? cls?.name ?? cls?.class?.name
                      }))}
                      value={(metadataForm?.class_id || []).map((cls) => ({
                        value: cls?.id,
                        label: cls?.name,
                        id: cls?.id,
                        name: cls?.name
                      }))}
                      onChange={handleMetadataClassChange}
                      placeholder="Select Class(es)"
                    />
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Subject"
                    children={(
                      <select
                        name="subject_id"
                        value={metadataForm.subject_id}
                        onChange={handleMetadataChange}
                      >
                        <option value="">--- Select ---</option>
                        {(allClassSubject || []).map((sub) => (
                          <option
                            key={sub?.subject?.id || sub?.subject_id}
                            value={sub?.subject?.id || sub?.subject_id}
                          >
                            {sub?.displayName || sub?.subject?.name || sub?.subject_name}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Session"
                    children={(
                      <select
                        name="session_id"
                        value={metadataForm.session_id}
                        onChange={handleMetadataChange}
                      >
                        <option value="">--- Select ---</option>
                        {(sessionData || []).map((session) => (
                          <option key={session?.id} value={session?.id}>{session?.session}</option>
                        ))}
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Term"
                    children={(
                      <select
                        name="term_id"
                        value={metadataForm.term_id}
                        onChange={handleMetadataChange}
                      >
                        <option value="">--- Select ---</option>
                        {(allTerm || []).map((term) => (
                          <option key={term?.id} value={term?.id}>{term?.term}</option>
                        ))}
                      </select>
                    )}
                  />
                </Grid>

                {/* Exam Metadata */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Title"
                    inputName="title"
                    margin="normal"
                    inputType="text"
                    placeHolder="Enter exam title"
                    value={metadataForm.title}
                    onChange={handleMetadataChange}
                    required
                  />
                  {createExamValidator.message("title", metadataForm.title?.trim(), "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextAreaGroup
                    label="Description"
                    inputName="description"
                    margin="normal"
                    placeholder="Enter description"
                    value={metadataForm.description}
                    onChange={handleMetadataChange}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextAreaGroup
                    label="Examination Instruction"
                    inputName="instruction"
                    margin="normal"
                    placeholder="Enter instructions"
                    value={metadataForm.instruction}
                    onChange={handleMetadataChange}
                  />
                </Grid>

                {/* Time Configuration */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Duration (minutes)"
                    inputName="duration"
                    margin="normal"
                    inputType="number"
                    placeHolder="Enter duration"
                    value={metadataForm.duration}
                    onChange={handleMetadataChange}
                    required
                  />
                  {createExamValidator.message(
                    "duration",
                    isMetadataDurationValid() ? metadataForm.duration : "",
                    "required"
                  )}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Total Grade"
                    inputName="total_grade"
                    margin="normal"
                    inputType="number"
                    placeHolder="e.g. 100"
                    value={metadataForm.total_grade}
                    onChange={handleMetadataChange}
                    disabled
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Time per Question (optional)"
                    inputName="time_per_question"
                    margin="normal"
                    inputType="number"
                    placeHolder="e.g. 2"
                    value={metadataForm.time_per_question}
                    onChange={handleMetadataChange}
                  />
                </Grid>
                {!metadataForm.use_exam_schedule && (
                  <>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Exam Date"
                        inputName="exam_date"
                        margin="normal"
                        inputType="date"
                        value={metadataForm.exam_date}
                        onChange={handleMetadataChange}
                        required
                      />
                      {createExamValidator.message(
                        "exam_date",
                        metadataForm.exam_date,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <InputGroup
                        label="Start Time"
                        inputName="start_time"
                        margin="normal"
                        inputType="time"
                        value={metadataForm.start_time}
                        onChange={handleMetadataChange}
                        required
                      />
                      {createExamValidator.message(
                        "start_time",
                        metadataForm.start_time,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <InputGroup
                        label="End Time"
                        inputName="end_time"
                        margin="normal"
                        inputType="time"
                        value={metadataForm.end_time}
                        onChange={handleMetadataChange}
                        required
                      />
                      {createExamValidator.message(
                        "end_time",
                        metadataForm.end_time,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {metadataForm.start_time && metadataForm.end_time && (
                        <>
                          {!metadataScheduleTimesOrderOk && (
                            <p style={{ color: "#d32f2f", fontSize: 14, margin: "4px 0 0" }}>
                              Start time must be before end time.
                            </p>
                          )}
                          {metadataScheduleTimesOrderOk && metadataScheduleWindowMins != null && (
                            <p style={{ color: "#667185", fontSize: 14, margin: "4px 0 0" }}>
                              Exam window: <strong>{metadataScheduleWindowMins}</strong> minutes
                            </p>
                          )}
                        </>
                      )}
                    </Grid>
                  </>
                )}
                <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", gap: 12 }}>
                  <FormControlLabel
                    control={(
                      <Checkbox
                        name="use_exam_schedule"
                        checked={!!metadataForm.use_exam_schedule}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setMetadataForm((prev) => ({
                            ...prev,
                            use_exam_schedule: checked,
                            ...(checked ? { exam_date: "", start_time: "", end_time: "" } : {})
                          }));
                        }}
                        color="primary"
                      />
                    )}
                    label={(
                      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        Use Exam Schedule
                        <Tooltip
                          title="If checked, Exam start date and End date would not be used and this exam will need to be scheduled in exam schedule"
                          arrow
                          placement="top"
                        >
                          <span style={{ display: "inline-flex", cursor: "help" }}>
                            <Icon icon="mdi:help-circle-outline" width={18} height={18} style={{ color: "#667185" }} />
                          </span>
                        </Tooltip>
                      </span>
                    )}
                  />
                  <FormControlLabel
                    control={(
                      <Checkbox
                        name="is_private"
                        checked={!!metadataForm.is_private}
                        onChange={handleMetadataChange}
                        color="primary"
                      />
                    )}
                    label={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        Visibility (Private)
                        <Tooltip title="If checked, this exam will only be visible to assigned candidates." placement="top">
                          <Icon icon="mdi:information-outline" style={{ cursor: "pointer", fontSize: 18, marginLeft: 4 }} />
                        </Tooltip>
                      </span>
                    }
                  />
                </Grid>

                {/* Behavior Settings */}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Random Question"
                    children={(
                      <select
                        name="random_question"
                        value={metadataForm.random_question}
                        onChange={handleMetadataChange}
                      >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Randomize Options"
                    children={(
                      <select
                        name="random_options"
                        value={metadataForm.random_options}
                        onChange={handleMetadataChange}
                      >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Display Score after Exam"
                    children={(
                      <select
                        name="display_score_after_exam"
                        value={metadataForm.display_score_after_exam}
                        onChange={handleMetadataChange}
                      >
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Question Display Mode"
                    children={(
                      <select
                        name="question_display_mode"
                        value={metadataForm.question_display_mode}
                        onChange={handleMetadataChange}
                      >
                        <option value="">--- Select ---</option>
                        <option value="all">All at once</option>
                        <option value="one">One per page</option>
                      </select>
                    )}
                  />
                </Grid>

                {/* Security Settings */}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        Proctoring requirements
                        <Tooltip title="Specifies the security and monitoring measures enforced during the exam (e.g., Basic, Strict)." placement="top">
                          <Icon icon="mdi:information-outline" style={{ cursor: "pointer", fontSize: 18, marginLeft: 4 }} />
                        </Tooltip>
                      </span>
                    }
                    children={(
                      <select
                        name="proctoring_requirements"
                        value={metadataForm.proctoring_requirements}
                        onChange={handleMetadataChange}
                      >
                        <option value="">--- Select ---</option>
                        <option value="none">None</option>
                        <option value="basic">Basic</option>
                        <option value="strict">Strict</option>
                      </select>
                    )}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16 }}>
                    <FormControlLabel
                      control={(
                        <Switch
                          name="browser_lockdown"
                          checked={metadataForm.browser_lockdown}
                          onChange={(e) => {
                            const { checked } = e.target;
                            setMetadataForm((prev) => ({
                              ...prev,
                              browser_lockdown: checked
                            }));
                          }}
                          color="primary"
                        />
                      )}
                      label="Browser Lockdown"
                    />
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2} sx={{ width: "100%", marginTop: 1 }}>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Button
                        variant="primaryoutline"
                        buttonSize="full"
                        color="btnfontprimary"
                        buttonName="Cancel"
                        onClick={handleCloseMetadataDrawer}
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Button
                        variant="primary"
                        buttonSize="full"
                        color="btndefault"
                        buttonName="Save Changes"
                        onClick={handleSaveMetadata}
                        disabled={JSON.stringify(metadataForm) === JSON.stringify(initialMetadataForm)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </RightDrawer>
            <GenerateQuestionsDrawer
              open={isGenerateDrawerOpen}
              onClose={() => setIsGenerateDrawerOpen(false)}
              isAdmin={isAdmin}
              lessonOutlineId={lessonOutlineFromState?.lesson_outline_id}
              versionId={lessonOutlineFromState?.version_id}
              initialDestinationType="school_exam"
              initialDestinationId={examConfigId}
              examContext={{
                title: schoolExamData?.title,
                subjectName: schoolExamData?.subject?.name,
                subjectId: schoolExamData?.subject?.id ?? schoolExamData?.subject_id,
                classLabel: schoolExamData?.classes?.map((cls) => cls?.name).filter(Boolean).join(", "),
                description: schoolExamData?.description || schoolExamData?.config?.description || ""
              }}
            />
          </div>
        </>
      }
    />
  );
};

export default SchoolExamDetails;
